import { combineReducers } from '@ngrx/store';
import * as fromRetailSpecifications from './retail-specification.reducer';
import * as fromProducts from './products.reducer';
import * as fromGrouping from './grouping.reducer';
import * as fromMinLot from './min-lot.reducer';
import * as fromNextWorkingDay from './next-working-day.reducer';
import * as fromAdditionalServices from './additional-services.reducer';

export interface RetailSpecificationState {
  retailSpecificationState: fromRetailSpecifications.RetailSpecificationFormState;
  productsState: fromProducts.ProductsState;
  groupingState: fromGrouping.GroupingState;
  minLotState: fromMinLot.MinLotState;
  nextWorkingDayState: fromNextWorkingDay.NextWorkingDayState;
  additionalServicesState: fromAdditionalServices.AdditionalServicesState;
}

export const reducers = combineReducers({
  retailSpecificationState: fromRetailSpecifications.specificationFormReducer,
  productsState: fromProducts.productsReducer,
  groupingState: fromGrouping.groupingReducer,
  minLotState: fromMinLot.reducer,
  nextWorkingDayState: fromNextWorkingDay.reducer,
  additionalServicesState: fromAdditionalServices.additionalServicesReducer,
});
